const init = function() {
  
  var catf_calc_tips = document.body.querySelectorAll('.tool-tip');

  var resetPopup = function( popup ) {
    popup.classList.remove('is-left')
  }

  var repositionPopup = function( popup ) {

    if ( popup.getBoundingClientRect().left < 0 ) {
      popup.classList.add('is-left')
    } else if ( popup.getBoundingClientRect().right > window.innerWidth ) {
      popup.classList.add('shift-left')
    } else {
      resetPopup( popup )
    }
  }

  catf_calc_tips.forEach( function( tip ) {
    
    var button  = tip.querySelector('.tool-tip__button')
    var message = button.getAttribute( 'data-status' )
    var popup   = tip.querySelector('.tool-tip__info-box')
  
    button.addEventListener( 'mouseover', function() {
      popup.textContent = message
      popup.style.display = 'block'
      repositionPopup( popup );
    } )
  
    button.addEventListener( 'focus', function() {
      popup.textContent = message
      popup.style.display = 'block'
      repositionPopup( popup );
    } )
  
    button.addEventListener( 'mouseleave', function() {
      popup.textContent = ''
      popup.style.display = 'none'
      repositionPopup( popup )
    } )
  
    button.addEventListener( 'blur', function() {
      popup.textContent = ''
      popup.style.display = 'none'
      repositionPopup( popup )
    } )
  
  } )

};


const api = {
	init: init
};

export default api;